<template>
  <div>
    <b-field type="is-vert-clair">
      <b-select placeholder="Select a name" v-model="typeSelect" rounded>
        <option value="">Trier par...</option>
        <option v-for="type in listeTypes" :key="type.id" :value="type.nom">
          {{ type.nom }}
        </option>
      </b-select>
      <b-select
        v-model="quantiteSelect"
        rounded
        v-show="this.typeSelect === 'vinaigre'"
      >
        <option value="">Trier par quantitée</option>
        <option value="50">50 ml</option>
        <option value="100">100 ml</option>
        <option value="200">200 ml</option>
      </b-select>
      <b-input
        placeholder="Rechercher..."
        type="search"
        icon="search"
        v-model="recherche"
        rounded
      ></b-input>
    </b-field>
    <div class="columns is-multiline is-mobile">
      <div
        v-for="(produit, index) in listeProduits"
        v-bind:key="index"
        class="column is-6-mobile is-3-tablet is-2-desktop"
        v-show="
          isSearch(produit.nom) &&
          isTypeSelect(produit.type) &&
          isQuantiteSelect(produit.quantite)
        "
      >
        <div class="card is-liste">
          <div class="card-image">
            <figure class="image is-4by3">
              <img :src="produit.image" alt="Placeholder image" />
            </figure>
          </div>
          <div class="card-footer" :class="produit.stock ? '' : 'is-sold-out'">
            <p class="card-footer-item">{{ produit.prix }}€</p>
            <p class="card-footer-item">{{ produit.quantite }} ml</p>
          </div>
          <div class="card-footer" :class="produit.stock ? '' : 'is-sold-out'">
            <p class="card-footer-item">{{ produit.nom }}</p>
          </div>
          <footer
            class="card-footer"
            :class="produit.stock ? '' : 'is-sold-out'"
          >
            <b-button
              class="card-footer-item is-info"
              @click="detailModal(produit)"
              >Modifier</b-button
            >
            <b-button
              class="card-footer-item is-danger"
              @click="deleteProduit(produit)"
              >Supprimer</b-button
            >
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListeProduits from "../classes/ListeProduits.js";
import AdminDetailProduit from "@/components/AdminDetailProduit.vue";

export default {
  name: "ListeProduits",
  created() {
    this.updateListeProduits();
  },
  data() {
    return {
      recherche: "",
      typeSelect: "",
      quantiteSelect: "",
    };
  },
  computed: {
    listeProduits() {
      const resultat = this.$store.state.listeProduits;
      return (resultat || { liste: [] }).liste;
    },
    listeTypes() {
      const resultat = this.$store.state.listeTypes;
      return (resultat || { liste: [] }).liste;
    },
  },
  methods: {
    updateListeProduits: async function () {
      const maListe = new ListeProduits();
      await maListe.getProduits();
    },
    deleteProduit: async function (produit) {
      await produit.deleteProduit();
      this.updateListeProduits();
    },
    isSearch(nom) {
      return !this.recherche
        ? true
        : nom.toLowerCase().includes(this.recherche.toLowerCase());
    },

    isTypeSelect(type) {
      return !this.typeSelect
        ? true
        : type.toLowerCase() == this.typeSelect.toLowerCase();
    },
    isQuantiteSelect(quantite) {
      return this.typeSelect === "vinaigre"
        ? !this.quantiteSelect
          ? true
          : quantite == this.quantiteSelect
        : true;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      }
      return false;
    },
    detailModal(produit) {
      this.$buefy.modal.open({
        parent: this,
        props: produit,
        component: AdminDetailProduit,
        width: 1600,
        fullScreen: this.isMobile() ? true : false,
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.is-sold-out
  background-color: red !important
</style>
